:host {
  display: block;
}